:host {
  display: block;
}